(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shopby-gemstones"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const gemstoneGrid = document.querySelector('.gemstone-grid');
    let flkty;

    function initOrDestroyFlickity() {
      if (window.innerWidth <= 767) {
        if (!flkty) {
          flkty = new Flickity(gemstoneGrid, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            groupCells: 3,
            cellSelector: '.gemstone-item'
          });
        }
      } else {
        if (flkty) {
          flkty.destroy();
          flkty = null;
        }
      }
    }

    initOrDestroyFlickity();
    window.addEventListener('resize', initOrDestroyFlickity);
  });

  } catch(e) { console.error(e); }
})();
})();
